import { createElement } from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';
import type { IconBaseProps, IconType } from 'react-icons';

interface SafeIconProps extends IconBaseProps {
  icon?: IconType;
  name?: string;
}

const SafeIcon = ({ icon, name, ...props }: SafeIconProps) => {
  const namedIcon = name ? FiIcons[`Fi${name}` as keyof typeof FiIcons] : null;
  const IconComponent = icon ?? (typeof namedIcon === 'function' ? namedIcon : null);

  return IconComponent
    ? createElement(IconComponent, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;
